import type { SignatureIntent, SignatureVerificationLevel } from '@/enum/global.enum'

const signatureIntentLabel: Record<SignatureIntent, string> = {
  REVIEWED: 'Reviewed',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  ACKNOWLEDGED: 'Acknowledged',
  ATTESTED: 'Attested',
}

const intentColor: Record<SignatureIntent, string> = {
  REVIEWED: 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300',
  APPROVED: 'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-300',
  REJECTED: 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300',
  ACKNOWLEDGED: 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-300',
  ATTESTED: 'bg-purple-100 text-purple-800 dark:bg-purple-950 dark:text-purple-300',
}

/** Phrased as what was actually established, not as proof of identity. */
const verificationLabel: Record<SignatureVerificationLevel, string> = {
  EMAIL_LINK: 'Verified by signing link',
  EMAIL_OTP: 'Verified by email code',
  AUTHENTICATED: 'Signed in session',
  SSO: 'Verified by single sign-on',
}

export { intentColor, signatureIntentLabel, verificationLabel }
